function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { createContext, useContext, useEffect, useState } from 'react';
import Spacer from "../ui/spacer/Spacer";
import { form_validator } from "../form/FormFieldValidator";
import Feedback from "../feedback/Feedback";
import { FormContext } from "noood/contexts/contexts";
export var RadioGroupContext = /*#__PURE__*/createContext();
export default function RadioGroup(props) {
  var _form_$formObj2;
  var _useState = useState(props.value),
    _useState2 = _slicedToArray(_useState, 2),
    val = _useState2[0],
    set_val = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    errors = _useState4[0],
    set_errors = _useState4[1];
  // let form_collector = useContext(FormFieldCollectorContext);
  var form_ = useContext(FormContext);
  var __choose = function __choose(value) {
    var _form_$__collect;
    set_val(value);
    var validation_errors = form_validator.validate(props.validations, value);
    form_ === null || form_ === void 0 || (_form_$__collect = form_.__collect) === null || _form_$__collect === void 0 || _form_$__collect.call(form_, props.name, value, validation_errors);
    set_errors(validation_errors);
  };
  useEffect(function () {
    set_val(props.value);
  }, [props.value]);
  useEffect(function () {
    var _form_$formObj;
    set_val((_form_$formObj = form_.formObj) === null || _form_$formObj === void 0 ? void 0 : _form_$formObj[props.name]);
  }, [(_form_$formObj2 = form_.formObj) === null || _form_$formObj2 === void 0 ? void 0 : _form_$formObj2[props.name]]);
  return /*#__PURE__*/React.createElement(RadioGroupContext.Provider, {
    value: {
      __choose: __choose,
      val: val
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-label"
  }, props.label), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 2
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: '5px'
    }
  }, props.children), (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && /*#__PURE__*/React.createElement(Feedback, {
    errors: errors
  }));
}